import { DashboardItem } from '@shared/models/dashboard-item.model';

export class LayoutConfig {
  version: string;
  dashboardItems: DashboardItem[];
  selectedDashboardItemsIds: number[];

  selectedDashboardItems?: DashboardItem[];
}
